(function () {
  function syncMobileCarousel(panel, targetIndex, behavior) {
    const mobileTrack = panel.querySelector('[data-mobile-track]');
    const targetSlide = panel.querySelector(`[data-mobile-slide="${targetIndex}"]`);

    if (!mobileTrack || !targetSlide) return;

    const left = targetSlide.offsetLeft;
    mobileTrack.scrollTo({
      left,
      behavior: behavior || 'smooth'
    });
  }

  function setAccordionState(panel, targetIndex, options) {
    const settings = Object.assign({ syncMobile: true, scrollBehavior: 'smooth' }, options || {});
    const items = Array.from(panel.querySelectorAll('[data-accordion-item]'));
    const hotspots = Array.from(panel.querySelectorAll('[data-hotspot-index]'));
    const mobileSlides = Array.from(panel.querySelectorAll('[data-mobile-slide]'));
    const mobileDots = Array.from(panel.querySelectorAll('[data-mobile-dot]'));

    items.forEach((item) => {
      const isActive = item.dataset.accordionItem === String(targetIndex);
      const answer = item.querySelector('[data-answer]');
      item.classList.toggle('is-active', isActive);
      if (answer) {
        answer.style.maxHeight = isActive ? `${answer.scrollHeight}px` : '0px';
      }
    });

    hotspots.forEach((hotspot) => {
      hotspot.classList.toggle('is-active', hotspot.dataset.hotspotIndex === String(targetIndex));
    });

    mobileSlides.forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.mobileSlide === String(targetIndex));
    });

    mobileDots.forEach((dot) => {
      dot.classList.toggle('is-active', dot.dataset.mobileDot === String(targetIndex));
    });

    panel.dataset.activeIndex = String(targetIndex);

    if (settings.syncMobile) {
      syncMobileCarousel(panel, targetIndex, settings.scrollBehavior);
    }
  }

  function activateTab(section, tabId) {
    const buttons = Array.from(section.querySelectorAll('[data-tab-button]'));
    const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));

    buttons.forEach((button) => {
      const isActive = button.dataset.tabButton === tabId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabPanel === tabId;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        const activeItem = panel.querySelector('[data-accordion-item].is-active');
        const firstItem = panel.querySelector('[data-accordion-item]');
        const targetIndex = activeItem?.dataset.accordionItem || firstItem?.dataset.accordionItem;
        if (targetIndex) setAccordionState(panel, targetIndex);
      }
    });

    const activeButton = buttons.find((button) => button.dataset.tabButton === tabId);
    const tabTitle = activeButton?.textContent?.trim() || '';

    section.dispatchEvent(new CustomEvent('mattress-structure-tabs:change', {
      bubbles: true,
      detail: {
        tabId,
        title: tabTitle
      }
    }));
  }

  function initSection(section) {
    if (section.dataset.mstReady === 'true') return;
    section.dataset.mstReady = 'true';

    const tabButtons = Array.from(section.querySelectorAll('[data-tab-button]'));
    const panels = Array.from(section.querySelectorAll('[data-tab-panel]'));

    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        activateTab(section, this.dataset.tabButton);
      });
    });

    panels.forEach((panel) => {
      const questions = Array.from(panel.querySelectorAll('[data-question-index]'));
      const hotspots = Array.from(panel.querySelectorAll('[data-hotspot-index]'));
      const mobileDots = Array.from(panel.querySelectorAll('[data-mobile-dot]'));
      const mobileTrack = panel.querySelector('[data-mobile-track]');

      questions.forEach((question) => {
        question.addEventListener('click', function () {
          setAccordionState(panel, this.dataset.questionIndex);
        });
      });

      hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', function () {
          setAccordionState(panel, this.dataset.hotspotIndex);
        });
      });

      mobileDots.forEach((dot) => {
        dot.addEventListener('click', function () {
          setAccordionState(panel, this.dataset.mobileDot);
        });
      });

      if (mobileTrack) {
        let scrollTimer = null;

        mobileTrack.addEventListener('scroll', function () {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            const slides = Array.from(panel.querySelectorAll('[data-mobile-slide]'));
            if (!slides.length) return;

            const currentLeft = mobileTrack.scrollLeft;
            let nearestSlide = slides[0];
            let nearestDistance = Math.abs(slides[0].offsetLeft - currentLeft);

            slides.slice(1).forEach((slide) => {
              const distance = Math.abs(slide.offsetLeft - currentLeft);
              if (distance < nearestDistance) {
                nearestSlide = slide;
                nearestDistance = distance;
              }
            });

            if (nearestSlide && panel.dataset.activeIndex !== nearestSlide.dataset.mobileSlide) {
              setAccordionState(panel, nearestSlide.dataset.mobileSlide, {
                syncMobile: false,
                scrollBehavior: 'auto'
              });
            }
          }, 80);
        });
      }

      const firstItem = panel.querySelector('[data-accordion-item]');
      if (firstItem) {
        setAccordionState(panel, firstItem.dataset.accordionItem, {
          scrollBehavior: 'auto'
        });
      }
    });

    const initialTab = tabButtons.find((button) => button.classList.contains('is-active'))?.dataset.tabButton || tabButtons[0]?.dataset.tabButton;
    if (initialTab) activateTab(section, initialTab);
  }

  function initAll() {
    document.querySelectorAll('[data-mattress-structure-tabs]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
